import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]

import { ref } from 'vue';
	import { Swiper, SwiperSlide } from 'swiper/vue';
	import { Pagination, Navigation } from 'swiper/modules';
	import 'swiper/css';
	import 'swiper/css/pagination';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'ImageSwiperComponent',
  props: {
    type: {},
    images: {},
    customClass: {}
  },
  setup(__props: any) {

	const modules = [Pagination, Navigation];
	const props = __props;
	const pagination = ref({
		clickable: true,
		renderBullet: (index, className) => {
			return `<div class="${className}"><img src="${props.images[index]?.toString()}"/></div>`;
		},
	})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Swiper), {
    pagination: (_ctx.type=='BULLET' || _ctx.images.length===1)?false:pagination.value,
    navigation: (_ctx.type=='BULLET'?true:false),
    modules: modules,
    class: _normalizeClass(['gallery-swiper', {'no-margin': _ctx.type=='BULLET'}, _ctx.customClass])
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.images, (image, index) => {
        return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "product-img",
              src: image.toString(),
              alt: "Imagen del producto"
            }, null, 8, _hoisted_1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["pagination", "navigation", "class"]))
}
}

})